import { inject } from 'vue';

export default function useMapMarker() {
  const domain = inject('domain');

  function createMapMarker(OverlayView, args) {
    class HTMLMapMarker extends OverlayView {
      #position;

      constructor() {
        super();
        this.map = args.map;
        this.#position = args.position;
        this.direction = args.direction;
        this.draggable = args.draggable;
        this.onDragEnd = args.onDragEnd;
        this.initMarker(args);
        this.setMap(args.map);
      }

      get position() {
        return this.#position;
      }

      set position(value) {
        this.#position = value;
        this.marker.setPosition(value);
        this.animation?.setPosition(value);
      }

      initMarker({ animated }) {
        this.marker = new google.maps.Marker({
          position: this.#position,
          draggable: this.draggable,
          optimized: false,
          icon: {
            url: this.direction === 'to' ? 'svg/map_pin_to.svg?v=2026' : `svg/${domain.name}/map_pin_${this.direction}.svg?v=2026`,
            scaledSize: new google.maps.Size(54, 54),
          },
        });

        this.marker.setMap(this.map);

        if (animated) {
          this.animation = new google.maps.Marker({
            position: this.#position,
            icon: {
              url: 'img/pulse.png',
              scaledSize: new google.maps.Size(200, 200),
              anchor: new google.maps.Point(100, 100),
            },
          });

          this.animation.setMap(this.map);
        }

        if (this.draggable) {
          google.maps.event.addListener(this.marker, 'dragend', (marker) => {
            this.onDragEnd(this.direction, marker);
          });
        }
      }

      remove() {
        this.marker?.setMap(null);
        this.animation?.setMap(null);
      }
    }

    return new HTMLMapMarker();
  }

  return {
    createMapMarker,
  };
}
